<template>
  <v-flex xs12 sm12 md6 lg4 xl3>
    <v-hover>
      <v-card
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 12 : 2}`"
        :to="{ name: 'mls-listing', params: { mlsId: listing.mlsId } }"
      >
        <v-img
          v-if="listing.photos.length"
          :src="listing.photos[0]"
          aspect-ratio="1.77"
          class="white--text"
        >
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex align-end flexbox pa-0>
                <v-chip
                  color="green darken-1"
                  text-color="white"
                  class="title right"
                >
                  {{ listing.listPrice | currency('$', 0) }}
                </v-chip>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
        <v-img v-else :src="image" aspect-ratio="1.77" class="white--text">
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex align-end flexbox pa-0>
                <v-chip
                  color="green darken-1"
                  text-color="white"
                  class="title right"
                >
                  {{ listing.listPrice | currency('$', 0) }}
                </v-chip>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
        <v-card-title primary-title>
          <div>
            <h3 class="title mb-0">{{ listing.address.full }}</h3>
            <p class="subheading grey--text">
              {{ listing.address.city }}, NV
              {{ listing.address.postalCode }}
            </p>
          </div>
        </v-card-title>
        <v-card-text class="pt-0">
          <v-layout align-center justify-center row text-xs-center>
            <v-flex subheading>{{ listing.property.bedrooms }} Beds</v-flex>
            <v-flex subheading>
              {{
                setNumBaths(
                  listing.property.bathsFull,
                  listing.property.bathsHalf
                )
              }}
              &nbsp;Baths
            </v-flex>
            <v-flex subheading>
              {{ listing.property.area | currency('', 0) }} Sq. Ft.
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            color="info"
            :to="{ name: 'mls-listing', params: { mlsId: listing.mlsId } }"
          >
            Explore
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-hover>
  </v-flex>
</template>

<script>
export default {
  name: 'ListingCard',
  props: {
    listing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      image: require('../assets/desert.jpg'),
    };
  },
  methods: {
    setNumBaths(full, half) {
      return (full + half / 2).toString();
    },
  },
};
</script>
